document.addEventListener('DOMContentLoaded', () => {
  const closeMobilePanel = (btn, panel) => {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Open menu');
    }
  };

  document.querySelectorAll('[data-orv-mobile-toggle]').forEach((btn) => {
    const id = btn.getAttribute('aria-controls');
    const panel = id ? document.getElementById(id) : null;

    btn.addEventListener('click', () => {
      if (!panel) return;
      const open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });

    panel?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => closeMobilePanel(btn, panel));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-orv-mobile-toggle][aria-expanded="true"]').forEach((btn) => {
      const id = btn.getAttribute('aria-controls');
      closeMobilePanel(btn, id ? document.getElementById(id) : null);
    });
  });

  document.querySelectorAll('[data-orv-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.orv-product-mainmedia img');
    gallery.querySelectorAll('[data-orv-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.dataset.src;
        main.srcset = '';
        main.alt = thumb.dataset.alt || main.alt;
        gallery.querySelectorAll('[data-orv-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-orv-product-form]').forEach((formWrap) => {
    const qty = formWrap.querySelector('[data-orv-qty]');
    formWrap.querySelectorAll('[data-orv-minus]').forEach((b) => b.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, Number(qty.value || 1) - 1);
    }));
    formWrap.querySelectorAll('[data-orv-plus]').forEach((b) => b.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, Number(qty.value || 1) + 1);
    }));
    formWrap.querySelectorAll('[data-orv-bundle]').forEach((row) => {
      row.addEventListener('click', () => {
        formWrap.querySelectorAll('[data-orv-bundle]').forEach((r) => r.classList.remove('is-active'));
        row.classList.add('is-active');
        if (qty) qty.value = row.dataset.quantity || 1;
      });
    });
    const variantSelect = formWrap.querySelector('[data-orv-variant]');
    const price = formWrap.closest('.orv-product-info')?.querySelector('[data-orv-price]');
    const compare = formWrap.closest('.orv-product-info')?.querySelector('[data-orv-compare]');
    let productDataPromise = null;
    const getProductData = () => {
      if (!productDataPromise) {
        const productPath = window.location.pathname.replace(/\/$/, '');
        productDataPromise = fetch(`${productPath}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.ok ? response.json() : null)
          .catch(() => null);
      }
      return productDataPromise;
    };
    const switchVariantImage = async (variantId) => {
      const gallery = formWrap.closest('.orv-product')?.querySelector('[data-orv-gallery]');
      const main = gallery?.querySelector('.orv-product-mainmedia img');
      if (!gallery || !main || !variantId) return;
      const productData = await getProductData();
      if (String(variantSelect?.value || '') !== String(variantId)) return;
      const selectedVariant = productData?.variants?.find((item) => String(item.id) === String(variantId));
      const featuredImage = selectedVariant?.featured_image;
      const imageSrc = typeof featuredImage === 'string' ? featuredImage : featuredImage?.src;
      if (!imageSrc) return;
      main.src = imageSrc;
      main.srcset = '';
      if (typeof featuredImage === 'object' && featuredImage?.alt) main.alt = featuredImage.alt;
      let matchedThumb = false;
      gallery.querySelectorAll('[data-orv-thumb]').forEach((thumb) => {
        let matches = false;
        try {
          matches = new URL(thumb.dataset.src, window.location.origin).pathname === new URL(imageSrc, window.location.origin).pathname;
        } catch (_) {
          matches = thumb.dataset.src === imageSrc;
        }
        thumb.classList.toggle('is-active', matches);
        if (matches) matchedThumb = true;
      });
      if (!matchedThumb) gallery.querySelectorAll('[data-orv-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
    };
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.style.display = option.dataset.compare ? '' : 'none';
        }
        switchVariantImage(option.value);
      });
      switchVariantImage(variantSelect.value);
    }
  });

  document.querySelectorAll('[data-orv-tabs]').forEach((root) => {
    const buttons = root.querySelectorAll('[data-orv-tab-button]');
    const panels = root.querySelectorAll('[data-orv-tab-panel]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      const target = button.dataset.orvTabButton;
      buttons.forEach((b) => b.classList.toggle('is-active', b === button));
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.orvTabPanel === target));
    }));
  });

  document.querySelectorAll('[data-orv-sort]').forEach((sort) => {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  });

  const storageGet = (key) => {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  };
  const storageSet = (key, value) => {
    try { localStorage.setItem(key, value); } catch (_) {}
  };

  document.querySelectorAll('[data-orv-countdown]').forEach((timer) => {
    const hours = Math.max(1, Number(timer.dataset.hours || 48));
    const key = `orv-countdown-${timer.dataset.key || 'default'}`;
    let end = Number(storageGet(key) || 0);
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600000;
      storageSet(key, String(end));
    }

    let intervalId = null;
    const set = (name, val) => {
      const el = timer.querySelector(`[data-${name}]`);
      if (el) el.textContent = String(val).padStart(2, '0');
    };
    const tick = () => {
      let diff = Math.max(0, end - Date.now());
      const days = Math.floor(diff / 86400000); diff %= 86400000;
      const hrs = Math.floor(diff / 3600000); diff %= 3600000;
      const mins = Math.floor(diff / 60000); diff %= 60000;
      const secs = Math.floor(diff / 1000);
      set('days', days); set('hours', hrs); set('minutes', mins); set('seconds', secs);
      if (end <= Date.now() && intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
    const startTimer = () => {
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
      tick();
      if (!document.hidden && end > Date.now()) intervalId = window.setInterval(tick, 1000);
    };

    startTimer();
    document.addEventListener('visibilitychange', startTimer);
  });
});
